import React from "react";
import { Table } from "../../lib";
import { mysqlDateToArabic, toArabicNumerals } from "../../helpers";
import { i18n, navigate } from "../../services";
import { MergeRequest } from "./index";
import { RowProps } from "../../lib/ui/Table";

type Props = {
    requests: Array<MergeRequest>;
};

export default class Requests extends React.Component<Props> {
    onRowClick = (r: Record<any, any>) => {
        const { id, doc_id, src_page_contents_id, dst_page_contents_id } = r;
        navigate.to(
            `/app/merge/resolve/${doc_id}/${id}/${src_page_contents_id}/${dst_page_contents_id}/`
        );
    };

    render() {
        const { requests } = this.props;

        const fields = [
            "num",
            "status",
            "name",
            "src_user_name",
            "dst_user_name",
            "created_at",
        ];
        const titles = [
            "merge.number",
            "merge.status",
            "merge.page_name",
            "merge.src_name",
            "merge.dst_name",
            "form.date",
        ];

        const transform: Record<string, (x: any) => string> = {
            num: toArabicNumerals,
            created_at: mysqlDateToArabic,
            status: (status: string) => i18n.get(`merge.${status}`),
        };

        const width = ["5%", "10%", "30%", "20%", "20%", "15%"];

        return (
            <Table
                width={width}
                titles={titles}
                fields={fields}
                transform={transform}
                rows={requests as unknown as RowProps[]}
                onRowClick={this.onRowClick}
            />
        );
    }
}
